export default __webpack_public_path__ + "static/media/Crop top.d577aa2d.png";